function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0732 7.75405L14.9921 2.7973C15.2191 2.57027 15.2191 2.22973 14.9921 2.0027L14.2353 1.20811C14.0083 0.981081 13.6678 0.981081 13.4407 1.20811L8.48398 6.16486C8.33263 6.31622 8.1056 6.31622 7.95425 6.16486L2.99749 1.17027C2.77047 0.943243 2.42993 0.943243 2.2029 1.17027L1.4083 1.96486C1.18128 2.19189 1.18128 2.53243 1.4083 2.75946L6.36506 7.71622C6.51641 7.86757 6.51641 8.09459 6.36506 8.24594L1.37047 13.2405C1.14344 13.4676 1.14344 13.8081 1.37047 14.0351L2.16506 14.8297C2.39209 15.0568 2.73263 15.0568 2.95965 14.8297L7.91641 9.87297C8.06776 9.72162 8.29479 9.72162 8.44614 9.87297L13.4029 14.8297C13.6299 15.0568 13.9705 15.0568 14.1975 14.8297L14.9921 14.0351C15.2191 13.8081 15.2191 13.4676 14.9921 13.2405L10.0732 8.28378C9.92182 8.13243 9.92182 7.9054 10.0732 7.75405Z"
});

function SvgFailedStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#EF4444",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedStatusIcon);
export default __webpack_public_path__ + "static/media/failedStatusIcon.b4d68934f4b7b962fa7a5846af719e33.svg";
export { ForwardRef as ReactComponent };